import { UiLockActions } from '../constants/ui_lock/ui_lock_actions';
import Dispatcher from '../dispatcher';

function showAction() {
    Dispatcher.handleUiLockAction({ type: UiLockActions.SHOW_ACTION });
}

function hideAction() {
    Dispatcher.handleUiLockAction({ type: UiLockActions.HIDE_ACTION });
}

export {
    showAction,
    hideAction
};